<!--
 * @Author: ‘巴博尔’ 2164119982@qq.com
 * @Date: 2023-11-07 10:44:46
 * @LastEditors: ‘巴博尔’ 2164119982@qq.com
 * @LastEditTime: 2023-11-27 10:33:10
 * @FilePath: \admin_pc\src\views\store-lesson-card\components\expCardVT.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div style="display: flex;align-items: center;margin-bottom: 30px;width: 60%;justify-content: center;">
      <div @click="changeLessonIdX(2)" :class="createParam.storeLessonCardTemplateId == 2 ? 'fdst' : 'fds'">
        A
      </div>
      <div @click="changeLessonIdX(1)" :class="createParam.storeLessonCardTemplateId == 1 ? 'fdst' : 'fds'">
        B
      </div>
    </div>
    <el-form ref="registerRef" :model="createParam" :rules="rules" label-width="90px">
      <div style="display: flex;">
        <div style="width: 35%;margin-top: 20px;">
          <!-- <el-form-item label="版本:" prop="userPhone">
            <el-select placeholder="请选择版本" v-model="createParam.storeLessonCardTemplateId"
              @change="changeLessonIdX">
              <el-option v-for="item in [
                { label: 'A', value: 1 },
                { label: 'B', value: 2 },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="业务选择:" prop="hostLessonsId">
            <el-select @change="changeBussinessId" v-model="createParam.hostLessonsId" placeholder="请选择">
              <el-option v-for="item in storeLessons" :key="item.storeLessonId" :label="item.name"
                :value="item.storeLessonId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="默认比例:" prop="defaultRatio">
            <el-input-number disabled v-model="createParam.defaultRatio" :min="0" :precision="1"></el-input-number>
          </el-form-item>
        </div>
        <div style="width: 65%;margin-top: 20px;">
          <div style="margin-left: 90px;margin-bottom: 20px;">
            兑换配置:
          </div>
          <el-form-item label="">
            <div v-for="(v, indtx ) in createParam.lessonsConversions" :key="indtx">
              <el-row>
                <el-col :span="10">
                  <el-select v-model="v.nextLessonsId" placeholder="请选择" style="width: 150px" clearable="">
                    <el-option v-for="fk in storeLessons" :key="fk.storeLessonId" :label="fk.name"
                      :value="fk.storeLessonId" :disabled="createParam.hostLessonsId == fk.storeLessonId ||
                        createParam.lessonsConversions
                          .map((mk) => {
                            return Number(mk.nextLessonsId);
                          })
                          .includes(fk.storeLessonId)
                        ? true
                        : false
                        ">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-input-number v-model="v.convertRatio" style="width: 150px" :min="0"
                    :precision="1"></el-input-number>
                  <i class="el-icon-circle-plus" v-if="indtx == createParam.lessonsConversions.length - 1"
                    style="font-size: 25px; cursor: pointer;color: #409eff;" @click="clickAdd"></i>
                  <i class="el-icon-remove" v-if="indtx == createParam.lessonsConversions.length - 1"
                    @click="clickDele(indtx)" style=" 
                  font-size: 25px;
                  cursor: pointer;
                  margin-left: 15px;
                  color: #409eff;
                "></i>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="clickTJYW" type="primary" class="operator-btn"
              icon="el-icon-circle-plus-outline">添加业务</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer-1" style="margin-top: 20px;">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleCreate('registerRef')">保存</el-button>
    </div>
    <worker-word ref="workerWord" :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>
    <el-dialog title="添加业务" :visible.sync="visibleDlgAddBusiness" width="50%" center :append-to-body="true">
      <div>
        <el-form ref="registerRef" :model="businessForm" :rules="bussRules" label-width="150px">
          <el-form-item label="卡类型:" prop="lessonTemplateId">
            <el-select v-model="businessForm.lessonTemplateId" placeholder="请选择卡类型" style="width: 270px">
              <el-option v-for="item in [
                { label: 'A', value: 2 },
                { label: 'B', value: 1 },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务名称" prop="name">
            <el-input v-model="businessForm.name" placeholder="请输入业务名称"></el-input>
          </el-form-item>
          <el-form-item label="业务描述" prop="descripe">
            <el-input v-model="businessForm.descripe" type="textarea" autosize placeholder="请输入业务描述"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure">确 认</el-button>
        <el-button @click="visibleDlgAddBusiness = false">取 消</el-button>
      </div>
    </el-dialog>
    <worker-words ref="workerWords" :key="refreshWords" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWords"></worker-words>
  </div>
</template>

<script>
import { qlLessonTemplate } from "@/api/StoreLesson";
import globaldata from "../../../utils/globaldata";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
import WorkerWords from "@/components/WorkerWord/WorkerWord";
import { updateMoreLessons, addStorelesson, getValByBusinessId } from "../../../api/StoreLessonCard";

export default {
  // props: {
  //   storeLessons: Array,
  // },
  components: { WorkerWord, WorkerWords },
  data() {
    return {
      refreshWord: new Date().getTime(),
      tData: {
        adminWord: ''
      },
      wordType: 0,
      showWordDlg: false,
      storeLessons: [],
      createParam: {
        defaultRatio: 1,
        hostLessonsId: '',
        storeLessonCardTemplateId: '',
        lessonsConversions: [{
          nextLessonsId: '',
          convertRatio: ''
        }],
      },
      rules: {
        name: [{ required: true, message: "请输入卡名称", trigger: "blur" }],
        descripe: [
          { required: true, message: "请输入卡描述", trigger: "blur" },
        ],
        storeLessonCardTemplateId: [
          { required: true, message: "请选择业务类型", trigger: "blur" },
        ],
        useType: [
          { required: true, message: "请选择使用类型", trigger: "blur" },
        ],
        optionsValue: [
          { required: true, message: "请选择计费类型", trigger: "blur" },
        ],
        totalClassCount: [
          { required: true, message: "请输入正价课时", trigger: "blur" },
        ],
        convertRatio: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
        defaultRatio: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
        hostLessonsId: [
          { required: true, message: "请选择业务类型", trigger: "blur" },
        ],
        validDays: [
          { required: true, message: "请选择卡有效时长", trigger: "blur" },
        ],
      },
      visibleDlgAddBusiness: false,
      businessForm: {},
      bussRules: {},
      isVip: globaldata.getAdminStore().isVip,

    };
  },

  mounted() { },

  methods: {
    handleWord(wordType, tData) {
      this.createParam.lessonsConversions.forEach((item) => {
        item.hostLessonsId = this.createParam.hostLessonsId
        item.storeFrontId = globaldata.getAdminStore().storeFrontId,
          item.defaultRatio = this.createParam.defaultRatio
      })
      let param = {
        storeFontId: globaldata.getAdminStore().storeFrontId,
        word: tData.adminWord,
        ...this.createParam
      }
      console.log(param, '===============')

      updateMoreLessons(param).then((res) => {
        if (res.code == 20000) {
          this.$emit("onBtnCreate");
        }
      })
    },
    // 添加业务按钮事件
    clickTJYW() {
      this.businessForm = {}
      this.visibleDlgAddBusiness = true
    },
    // 添加
    clickAdd() {
      this.createParam.lessonsConversions.push({
        nextLessonsId: '',
        convertRatio: ''
      })
    },
    clickDele(index) {
      this.$delete(this.createParam.lessonsConversions, index)
    },
    changeLessonIdX(e) {
      // console.log(e,'===============')
      // return
      this.createParam.storeLessonCardTemplateId = e
      this.createParam.hostLessonsId = ''
      this.createParam.lessonsConversions = [{
        nextLessonsId: '',
        convertRatio: ''
      }]
      this.createParam.lessonsId = ''
      qlLessonTemplate({
        lessonId: e,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }).then((res) => {
        if (res.code == 20000) {
          this.storeLessons = res.data
          this.storeLessons.forEach((item, index) => {
            this.createParam.lessonsConversions.push({
              nextLessonsId: '',
              convertRatio: ''
            })
            let idf = index + 1
            if (idf < 10) {
              item.name = '0' + idf + ' - ' + item.name
            } else {
              item.name = idf + ' - ' + item.name
            }
          })

        }
      })
    },
    changeBussinessId(e) {
      getValByBusinessId({ id: e }).then(res => {
        console.log(res, 'res')
        if (res.code == 20000) {
          // this.$set(this.createParam, 'defaultRatio', res.data.defaultRatio)
          if (res.data.storeLessonsConversionList && res.data.storeLessonsConversionList.length) {
            this.$set(this.createParam, 'lessonsConversions', res.data.storeLessonsConversionList)
          } else {
            this.$set(this.createParam, 'lessonsConversions', [{
              nextLessonsId: '',
              convertRatio: ''
            }])
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    handleCreate(registerRef) {
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      this.$refs[registerRef].validate((valid) => {
        if (valid) {
          // })
          for (var i = this.createParam.lessonsConversions.length; i > 0; i--) {
            // console.log(this.createParam.lessonsConversions[i-1],"this.createParam.lessonsConversions[i-1s]")
            if (this.createParam.lessonsConversions[i - 1].nextLessonsId === "") {
              this.$delete(this.createParam.lessonsConversions, i - 1)
            }
          }
          // console.log(this.createParam.lessonsConversions,"this.createParam.lessonsConversions[i]")

          // return
          this.$refs['workerWord'].showDlog = true

          // if (osd != 0) {
          //   this.$message.error('请选择兑换业务')
          // } else {
          // }
          //   let param = this.createParam;
          //   param.storeFrontId = globaldata.getAdminStore().storeFrontId;
          //   param.createAdminId = globaldata.getAdminStore().id;
          //   createUserChild(param).then((response) => {
          //     messageUtils.successMsg(this, "创建成功");
          //     this.$emit("onBtnCreate");
          //   });
        } else {
          return false;
        }
      });
    },
    handleWords(wordType, tData) {
      console.log(wordType, tData, 'wordType, tData======')
      let params = {
        ...this.businessForm,
        adminWord: tData.adminWord,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }
      addStorelesson(params).then(res => {
        if (res.code == 20000) {
          this.$message.success(res.message)
          if (this.createParam.storeLessonCardTemplateId != '') {
            this.changeLessonIdX(this.createParam.storeLessonCardTemplateId)
          }
          this.visibleDlgAddBusiness = false
        } else {
          this.$message.error(res.message)
        }

      })
    },
    handleSure() {
      this.$refs['workerWords'].showDlog = true
      return
      let params = {
        ...this.businessForm,
        adminWord: tData.adminWord,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }
      addStorelesson(params).then(res => {
        if (res.code == 20000) {
          this.visibleDlgAddBusiness = false
        } else {
          this.$message.error(res.message)
        }

      })
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-form-item {
  margin-bottom: 20px !important;
}

.fds {
  padding: 10px 60px;
  border: 1px solid;
  border-radius: 5px;
  margin-right: 30px;
}

.fdst {
  padding: 10px 60px;
  border-radius: 5px;
  margin-right: 30px;
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/views/store-lesson-card/components/muchCardVT.vue